import { useEffect } from 'react';
import { useRecoilState, useRecoilValue } from 'recoil';
import { initializeEngine } from '~/engine/Engine';
import { dicomProcessorState } from '~/state/atoms/dicomProcessorAtoms';
import { viewManagerState } from '~/state/atoms/engineAtoms';

/**
 * Starts the rendering engine and publishes its ViewManager. The engine
 * gets no input surface here: each viewer surface attaches its own. Once a
 * ViewManager is published, the hook does nothing more.
 */
export function useStartEngine(): void {
    const dicomProcessor = useRecoilValue(dicomProcessorState);
    const [viewManager, setViewManager] = useRecoilState(viewManagerState);

    useEffect(() => {
        if (viewManager) {
            return;
        }
        setViewManager(initializeEngine(dicomProcessor));
    }, [viewManager, dicomProcessor, setViewManager]);
}
